module.exports = __webpack_public_path__ + "static/img/su_zhou.0d8edc5f.png";